/**
 * Shared chart rendering limits.
 *
 * Kept in its own module so the chart factory and the message renderer agree on
 * one value. The renderer checks it before converting a wide-format payload —
 * that conversion is multiplicative (labels x series), so it can manufacture far
 * more points than the payload appears to hold, and exceeding the limit inside
 * the factory throws into an uncapped table fallback.
 */

/** Maximum number of data points a chart spec may carry. */
export const MAX_CHART_DATA_POINTS = 10000;

export default { MAX_CHART_DATA_POINTS };
